import React from 'react';
import RomanianPackage from '../../languages/RomanianPackage';

class DefaultPage extends React.Component {
    render(){
        return(
            <div>
                <p>{RomanianPackage.WELCOME_MESSAGE}</p>
            </div>
        )
    };
}
            

export default DefaultPage;


// WEBPACK FOOTER //
// ./src/views/Default/Default.js